module.exports = __webpack_public_path__ + "static/CalibreWeb-Light-25dbbb9b5cd64fd8d76d02f148801f11.eot";